import React from "react";
// import OnboardingActivity from "./OnboardingActivity";
// import OnboardingStats from "./OnboardingStats";
import CompanyInfoCard from "./CompanyInfoCard";
import HrInfo from "./HrInfo";
import OnboardingActivity from "./OverViewActivity";
import OnboardingStats from "./OverViewStats";
import CoachInfo from "./CoachInfo";
import NoteDocument from "./NoteDocument";

const OnboardingTab = ({ companyData ,refresh }) => {
    return (
        <div className="space-y-5">

            <div className="grid grid-cols-2 gap-5">
                <CompanyInfoCard companyData={companyData}  />
                <div className="grid grid-cols-1 gap-5">

                    <HrInfo companyData={companyData} refresh={refresh}  />
                    <CoachInfo companyData={companyData} />
                </div>
            </div>
            <div className="grid grid-cols-2 gap-5">
                <NoteDocument companyData={companyData} />

                <OnboardingStats companyData={companyData} />

            </div>
            <div className="grid grid-cols gap-12">

                <OnboardingActivity companyData={companyData} />
            </div>
        </div>
    );
};

export default OnboardingTab;